import React, { Component } from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap';
import { ChevronRight, DownloadCloud } from 'react-feather';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar'
import AOS from 'aos';
import '../styles/Home.css';
import LinkedinLogo from '../assets/images/LinkedinLogo.png';
import TwitterLogo from '../assets/images/TwitterLogo.png';
import InstagramLogo from '../assets/images/InstagramLogo.png';
import FlutterLogo from '../assets/images/languages/flutter.png';
import JavaLogo from '../assets/images/languages/java.png';
import JavascriptLogo from '../assets/images/languages/javascript.png';
import TypescriptLogo from '../assets/images/languages/typescript.png';
import ReactLogo from '../assets/images/languages/react.png';
import DartLogo from '../assets/images/languages/dart.png';
import Resume from '../assets/resume.pdf'

export default class Home extends Component {
    componentDidMount() {
        AOS.init({
            duration: 1000
        })
    }

    render() {
        return (
            <div className='home-css'>
                <header className='dark-bg'>
                    <Navbar />
                    <div className='main-header' >
                        <div class="design-container">
                            <div class="box">
                                <div class="spin-container">
                                    <div class="shape">
                                        <div class="bd"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="design-container2" >
                            <div className="box2">
                                <div className="spin-container2">
                                    <div className="shape2">
                                        <div className="bd"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <Container>

                            <div className='image-container mx-auto my-auto'>
                                <Image alt='logo' rounded src='https://res.cloudinary.com/emmanueljoshua/image/upload/v1631045455/header_image_n4njxb.jpg' fluid className='Image' />
                            </div>
                            <Col>
                                <h2 className='sub-head mt-1'>Mobil<span className='sub-head-e'>e</span><span className='sub-head-dot'>.</span> Web<span className='sub-head-dot'>.</span> Desktop<span className='sub-head-dot'>.</span></h2>
                            </Col>

                            <Col md='6' className='mx-auto my-auto'>
                                <p className='main-p'>
                                    Hi, I specialize in Mobile App Development with Flutter/ Dart and Web Development with JavaScript.</p>
                            </Col>


                            <a href={Resume} download="Emmanuel Joshua's resume">
                                <button class="learn-btn btn-pill mb-5">
                                    Download resume
                                  <div class="pro-icon ">
                                        <DownloadCloud size='17' />
                                    </div>
                                </button>
                            </a>


                        </Container>
                    </div>

                    <div >
                        <Container >
                            <Row>
                                <Col md='12'>
                                    <div className='techstack-view' data-aos='fade-up'>

                                        <Row>
                                            <Col md='6' className='d-flex align-items-center'>
                                                <div className='techstack-row'>
                                                    <h2>
                                                        My toolbox of skills<span className='sub-head-dot'>.</span>
                                                    </h2>
                                                    <p>
                                                        A collection of tools and technologies I'm comfortable working with.
                                            </p>
                                                </div>

                                            </Col>
                                            <Col md='6'>
                                                <div className='grid text-center'>
                                                    <Image src={FlutterLogo} alt="Iphone" className='image mx-auto my-auto' />
                                                    <Image src={DartLogo} alt="Iphone" className='image mx-auto my-auto' />
                                                    <Image src={JavascriptLogo} alt="Iphone" className='image mx-auto my-auto' />
                                                    <Image src={ReactLogo} alt="Iphone" className='image mx-auto my-auto' />
                                                    <Image src={TypescriptLogo} alt="Iphone" className='image mx-auto my-auto' />
                                                    <Image src={JavaLogo} alt="Iphone" className='image mx-auto my-auto' />
                                                </div>
                                            </Col>
                                        </Row>


                                    </div>
                                </Col>
                                <Col md='6' className='mx-auto my-auto' data-aos='fade-up'>
                                    <Link to='/portfolio' >
                                        <div className='projects-view text-center text-white'>
                                            <h6 className='projects-subhead d-flex justify-content-center align-items-center'> MY PROJECTS
                                            <div class="pro-icon ">
                                                    <ChevronRight size='17' />
                                                </div>
                                            </h6>
                                            <h2>
                                                Personal stuff.
                                        </h2>
                                            <div className='iphone '>
                                                <span className='binder mx-auto my-auto'>
                                                    <Image src='https://res.cloudinary.com/emmanueljoshua/image/upload/v1631044204/creditcard2_e55w2c.png' alt="Iphone" className='image mx-auto my-auto' width="267" height="579" />
                                                </span>
                                            </div>
                                        </div>
                                    </Link>
                                </Col>

                                <Col md='6' className='mx-auto my-auto' data-aos='fade-up'>
                                    <Link to='/portfolio'>
                                        <div className='products-view text-center text-white'>
                                            <h6 className='projects-subhead d-flex justify-content-center align-items-center'> MY PRODUCTS
                                            <div class="pro-icon ">
                                                    <ChevronRight size='17' />
                                                </div> </h6>
                                            <h2>
                                                Professional work.
                                        </h2>
                                            <div className='iphone '>
                                                <span className='binder mx-auto my-auto'>
                                                    <Image src='https://res.cloudinary.com/emmanueljoshua/image/upload/v1631044189/raven2_f8kl7p.png' alt="Iphone" className='image mx-auto my-auto' width="267" height="579" />
                                                </span>
                                            </div>
                                        </div>
                                    </Link>
                                </Col>

                            </Row>
                        </Container>
                    </div>

                    <div className='footer'>
                        <Container >
                            <Row>
                                <Col md='12'>
                                    <Row>
                                        <Col md='6'>
                                            <div >
                                                <p>FOLLOW ME</p>
                                                <div className='social-buttons'>
                                                    <div className='social-wrap'>
                                                        <a href='https://www.linkedin.com/in/joshuaemmanuel247' target="_blank" rel="noreferrer">
                                                            <Image alt='logo' rounded src={LinkedinLogo} fluid className='social-button' />
                                                        </a>
                                                    </div>

                                                    <div className='social-wrap'>
                                                        <a href='https://twitter.com/_emmanueljoshua' target="_blank" rel="noreferrer">
                                                            <Image alt='logo' rounded src={TwitterLogo} fluid className='social-button twitter' />
                                                        </a>
                                                    </div>

                                                    <div className='social-wrap'>
                                                        <a href='https://instagram.com/_emmanueljoshua' target="_blank" rel="noreferrer">
                                                            <Image alt='logo' rounded src={InstagramLogo} fluid className='social-button' />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md='6'>
                                            <div >
                                                <p>GOT SOMETHING TO SAY?</p>
                                                <div className='email-buttons'>
                                                    <div className='social-wrap'>
                                                        <a href='mailto:emmanueljoshua145@gmail.com' target="_blank" rel="noreferrer">
                                                            <span>emmanueljoshua145@gmail.com</span>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                    <div class="hr">
                                    </div>
                                    <div className='sub-footer d-flex justify-content-between align-items-center'>
                                        <h6>© 2021, Joshua Emmanuel.</h6>
                                        <h6>All right reserved.</h6>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>

                </header >
            </div>
        );
    }
}
